<div class="mb-2 mt-4 flex">
  <div class="w-[3px] shrink-0 bg-[#084673]"></div>
  <div class="content grow flex-col">
    <div class="ml-3 flex items-start justify-between">
      <span class="header italic">{{ author }} - {{ record.created | date }}</span>
      <aux-icon
        name="Trash"
        class="remove text-aux-error"
        (click)="!removeTooltip && !pending && onRemove()"
        [class.cursor-pointer]="!removeTooltip"
        [class.cursor-not-allowed]="!!removeTooltip"
        [class.opacity-70]="!!removeTooltip"
        [auxTooltip]="removeTooltip"
      />
    </div>
    <div class="ml-3 max-w-[80%] whitespace-pre-wrap">{{ record.text }}</div>
  </div>
</div>
